import {DeliveredContactCustomerTemplateType} from "../delivery/graphql/queries/getContractCustomerMessageTemplate";

/**
 * 默认消息模板常量
 * 用于在弱网或查询失败时返回默认模板
 */
export const DEFAULT_MESSAGE_TEMPLATES: DeliveredContactCustomerTemplateType[] = [
    {
        id: -1,
        chinese: '地址错误，准确的收件地址是什么？',
        english: 'Wrong address. What is the correct delivery address?',
        spanish: 'Dirección incorrecta. ¿Cuál es la dirección correcta de entrega?',
        detailMessage: "Hello, I'm your SwiftX courier delivering your package {tracking number} from {company}. However, the address provided appears to be incorrect. Could you please share the accurate delivery address? Thank you! I'll proceed with the delivery as soon as possible."
    },
    {
        id: -2,
        chinese: '门禁密码是什么？',
        english: 'What is the access code?',
        spanish: '¿Cuál es el código de acceso?',
        detailMessage: "Hello, I'm your SwiftX courier delivering your package {tracking number} from {company}. I'm unable to enter your community/apartment building. Could you please provide the access code? Thank you! I'll complete the delivery promptly."
    },
    {
        id: -3,
        chinese: '无法进入社区需要指导',
        english: 'Cannot enter the community, need guidance',
        spanish: 'No puedo acceder a la comunidad, necesito ayuda',
        detailMessage: "Hello, I'm your SwiftX courier delivering your package {tracking number} from {company}. I'm having trouble finding your residence. Could you please provide some guidance? Thank you! I'll ensure swift delivery upon clarification."
    },
    {
        id: -4,
        chinese: '联系不上收件人',
        english: 'Unable to contact the recipient',
        spanish: 'No puedo contactar al destinatario',
        detailMessage: "Hello, I'm your SwiftX courier delivering your package {tracking number} from {company}. I tried calling but couldn't reach you. May I know when you'll be available at home? Thank you! I'll arrange delivery at your convenience."
    }
];

